







































































import { Component, Vue, Watch } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import ImageUpload from '@/components/ImgUpload/index.vue'
import { addContestantRound, queryContestantRoundById, updateContestantRound } from '@/api/player.ts'
import { UserModule } from '@/store/modules/user'
import { baseUrl } from '@/config.json'
import { getToken } from '@/utils/cookies'
import { encrypt, decrypt } from '@/utils/crypto'

@Component({
  name: 'addPromotionalImage',
  components: {
    HeadLable,
    ImageUpload
  }
})
export default class extends Vue {
  private restKey: number = 0
  private textarea: string = ''
  private value: string = ''
  private title = '新增赛事轮次';
  private title1 = '';
  private imageUrl: string = ''
  private actionType: string = 'add'
  private vueRest = '1'
  private index = 0
  private inputStyle = { flex: 1 }
  private titleId = ''
  private titleId1 = ''
  private addType = 0
  private headers = {
    token: getToken()
  }
  private ruleForm = {
    id: '',
    title: '',
    rank: '',
    type: '',
    valueTime: '',
  }

  get rules() {
    return {
      title: {
        required: true,
        message: '赛事轮次标题不能为空'
      },
      rank: {
        required: true,
        message: '赛事轮次排序不能为空'
      },
    }
  }

  created() {
    this.titleId1 = this.$route.query.titleId;
    if (this.$route.query.title) {
      this.title1 = this.$route.query.title
    }
    this.actionType = this.$route.query.id ? 'edit' : 'add';
    this.name()
    if (this.$route.query.id) {
      this.title = '修改赛事轮次信息';
      this.init();
    }
  }

  private name() {
    try {
      // 解密
      this.titleId = decrypt(this.$route.query.titleId as string)
    } catch (e) {
      console.error("解密失败:", e)
      // this.title = "默认标题"
    }
  }

  changeAddType(number: number) {
    if (number == 0) {
      document.getElementById('add')!.style.backgroundColor = "#ffc200"
      document.getElementById('reduce')!.style.backgroundColor = "#f0f0f0"
      this.addType = 0
    } else {
      document.getElementById('reduce')!.style.backgroundColor = "#ffc200"
      document.getElementById('add')!.style.backgroundColor = "#f0f0f0"
      this.addType = 1
    }
  }

  cancel() {
    this.$router.push({ path: '/competition/scoreRoundManage', query: { titleId: this.titleId1, title: this.title1 } })
  }

  // 判断是否有权限
  private hasPermission(): boolean {
    const roles = UserModule.username || [];
    if (roles.includes('admin')) return true;
    return false;
  }

  private async init() {
    queryContestantRoundById(this.$route.query.id).then(res => {
      if (res && res.data && res.data.code === 1) {
        this.ruleForm = res.data.data
        this.ruleForm.type = res.data.data.type == 0 ? '个人赛' : res.data.data.type == 1 ? '团队赛' : '配对赛亲子赛'
      } else {
        this.$message.error(res.data.msg)
      }
    })
  }

  private submitForm(formName: any, st: any) {
    ;(this.$refs[formName] as any).validate((valid: any) => {
      console.log(valid, 'valid')
      if (valid) {
        if (!this.ruleForm.title) return this.$message.error('赛事轮次标题不能为空')
        if (!this.ruleForm.rank) return this.$message.error('赛事轮次排序不能为空')
        // if (!this.ruleForm.type) return this.$message.error('赛事轮次类型不能为空')
        // if (!this.ruleForm.valueTime) return this.$message.error('赛事轮次开始时间不能为空')
        // let params: any = { ...this.ruleForm }
        let params: any = {}
        // params.flavors = this.dishFlavors
        params.title = this.ruleForm.title
        params.rank = this.ruleForm.rank
        params.type = 0
        if (params.type == '个人赛' || params.type == '团队赛' || params.type == '配对赛亲子赛') {
          params.type = params.type == '个人赛' ? 0 : params.type == '团队赛' ? 1 : 2
        }
        params.startTime = this.ruleForm.valueTime
        // params.type = 1
        // params.price *= 100
        if (this.actionType == 'add') {
          params.titleId = this.titleId
          delete params.id
          addContestantRound(params)
            .then(res => {
              if (res.data.code === 1 && res.data.data != '请勿设置重复标题！') {
                this.$message.success('赛事轮次新增成功！')
                  this.$router.push({ path: '/competition/scoreRoundManage', query: { titleId: this.titleId1, title: this.title1 } })
              } else {
                this.$message.error(res.data.data || res.data.msg)
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        } else {
          delete params.createTime
          delete params.updateTime
          params.id = this.ruleForm.id
          params.titleId = this.titleId
          updateContestantRound(params)
            .then(res => {
              if (res && res.data && res.data.code === 1 && res.data.data != '请勿设置重复标题！') {
                this.$router.push({ path: '/competition/scoreRoundManage', query: { titleId: this.titleId1, title: this.title1 } })
                this.$message.success('赛事轮次信息修改成功！')
              } else {
                this.$message.error(res.data.data || res.data.msg)
              }
              // if (res.data.code == 200) {
              //   this.$router.push({'path': '/dish'})
              //   this.$message.success('菜品修改成功！')
              // } else {
              //   this.$message.error(res.data.desc || res.data.message)
              // }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        }
      } else {
        return false
      }
    })
  }

  imageChange(value: any) {
    this.ruleForm.photo = value
  }
}
